import { fetchApi } from '@/config/axiosSetting.ts';
import { FilesStaticsResponseQueryType } from '@/modules/Dashboard/queries/fileStaticChart/filesStaticsQuery.type.ts';

export const filesStatisticsQueryFunction =
  (): Promise<FilesStaticsResponseQueryType> => {
    return fetchApi.get('homepage/files_statistics/');
  };
